import Vue from 'vue'
import Router from 'vue-router'
import http from './utils/http.js'
Vue.use(Router)

// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
const index = () => import( /* webpackChunkName:"index"  */ './views/index.vue')
const login = () => import( /* webpackChunkName:"login"  */ './views/login.vue')
//用户中心模块
const user = () => import( /* webpackChunkName:"user"  */ './views/user/index.vue')
const colonelpage = () => import( /* webpackChunkName:"user"  */ './views/user/colonelpage.vue')
//商品中心模块
const goods = () => import( /* webpackChunkName:"goods"  */ './views/goods/index.vue')
const singleproduct = () => import( /* webpackChunkName:"goods"  */ './views/goods/singleproduct.vue')
const subsomeone = () => import( /* webpackChunkName:"goods"  */ './views/goods/subsomeone.vue')
const overview = () => import( /* webpackChunkName:"goods"  */ './views/goods/overview.vue')
const detail = () => import( /* webpackChunkName:"goods"  */ './views/goods/detail.vue')
const forgotpassword = () => import( /* webpackChunkName:"forgot"  */ './views/forgot/forgotpassword.vue')
const forgot = () => import( /* webpackChunkName:"forgot"  */ './views/forgot/forgot.vue')
const my = () => import( /* webpackChunkName:"my"  */ './views/my/index.vue')
const mypid = () => import( /* webpackChunkName:"my"  */ './views/my/mypid.vue')
const myjdpid = () => import( /* webpackChunkName:"my"  */ './views/my/myjdpid.vue')
const myinfo = () => import( /* webpackChunkName:"my"  */ './views/my/myinfo.vue')
const api = () => import( /* webpackChunkName:"my"  */ './views/my/api.vue')
const heads = () => import( /* webpackChunkName:"my"  */ './views/my/heads.vue')
const kollist = () => import( /* webpackChunkName:"my"  */ './views/my/kollist.vue')
const transaction = () => import( /* webpackChunkName:"my"  */ './views/my/transaction.vue')
const launchgoods = () => import( /* webpackChunkName:"my"  */ './views/my/launchgoods.vue')
const cooperation = () => import( /* webpackChunkName:"my"  */ './views/my/cooperation.vue')
const mycalendar = () => import( /* webpackChunkName:"my"  */ './views/my/mycalendar.vue')
const usercalendar = () => import( /* webpackChunkName:"my"  */ './views/my/usercalendar.vue')
const usercalendarinfo = () => import( /* webpackChunkName:"my"  */ './views/my/usercalendarinfo.vue')
const orderlist = () => import( /* webpackChunkName:"my"  */ './views/cpx/orderlist.vue')
const partner_info = () => import( /* webpackChunkName:"my"  */ './views/cpx/partner_info.vue')
const loadtask = () => import( /* webpackChunkName:"loadtask"  */ './views/my/loadtask.vue')
const ordertask = () => import( /* webpackChunkName:"ordertask"  */ './views/my/ordertask.vue')
const ordertaskdetail = () => import( /* webpackChunkName:"ordertaskdetail"  */ './views/my/ordertaskdetail.vue')
const media_questions = () => import( /* webpackChunkName:"media_questions"  */ '@/components/cpx/media_questions.vue')
const portrait_fans = () => import( /* webpackChunkName:"portrait_fans"  */ '@/views/my/portrait_fans.vue')
const loaddetail = () => import( /* webpackChunkName:"my"  */ './views/my/loaddetail.vue')
const cooperativegoods = () => import( /* webpackChunkName:"cooperativegoods"  */ './views/my/cooperativegoods.vue')
const cooperativehistory = () => import( /* webpackChunkName:"cooperativehistory"  */ './views/my/cooperativehistory.vue')
const cooperativedetail = () => import( /* webpackChunkName:"cooperativedetail"  */ './views/my/cooperativedetail.vue')


// const example = () => import( /* webpackChunkName:"my"  */ './views/my/example.vue')
// cpx部分
const cpx = () => import( /* webpackChunkName:"cpx"  */ './views/cpx/index.vue')
const cpxprogress = () => import( /* webpackChunkName:"cpx"  */ './views/cpx/cpxprogress.vue')
const cpxruning = () => import( /* webpackChunkName:"cpx"  */ './views/cpx/cpxruning.vue')
const cpxend = () => import( /* webpackChunkName:"cpx"  */ './views/cpx/cpxend.vue')
// 注册
const register = () => import( /* webpackChunkName:"register"  */ './views/register/index.vue')
const registerpage = () => import( /* webpackChunkName:"register"  */ './views/register/registerpage.vue')
const loginpage = () => import( /* webpackChunkName:"register"  */ './views/register/loginpage.vue')
const server = () => import( /* webpackChunkName:"server"  */ './views/my/server.vue')
//未授权
const auth = () => import( /* webpackChunkName:"A404"  */ './views/A404/auth.vue')
const example = () => import( /* webpackChunkName:"A404"  */ './views/A404/example.vue')
// A404
const A404 = () => import( /* webpackChunkName:"A404"  */ './views/A404/A404.vue')


const r = new Router({
    routes: [
        // {
        //     path: '/',
        //     name: 'index',
        //     component: index
        //     // redirect: '/index'
        // },
        { //概况概览
            path: '/mation',
            name: 'mation',
            component: goods,
            children: [{
                path: '/mation/overview',
                name: 'overview',
                component: overview,
            }]
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        { //申请但是还未通过审核
            path: '/auth',
            name: 'auth',
            component: auth

        },
        {
            path: '/example',
            name: 'example',
            component: example
        },
        { // 修改密码
            path: '/forgot',
            name: 'forgot',
            component: forgot,
            children: [{
                path: '/forgot/forgotpassword',
                name: 'forgotpassword',
                component: forgotpassword,
            }]
        },
        { // 注册
            path: '/register',
            name: 'register',
            component: register,
            children: [{
                path: '/register/registerpage',
                name: 'registerpage',
                component: registerpage,
            },
            {
                path: '/register/loginpage',
                name: 'loginpage',
                component: loginpage,
            }
            ]
        },
        { //用户中心
            path: '/user',
            name: 'user',
            component: user,
            children: [{
                path: '/user/colonelpage',
                name: 'colonelpage',
                component: colonelpage,
            }]
        },
        { //商品中心
            path: '/goods',
            name: 'goods',
            component: goods,
            children: [{
                path: '/goods/singleproduct',
                name: 'singleproduct',
                component: singleproduct,
            },
            {
                path: '/goods/subsomeone',
                name: 'subsomeone',
                component: subsomeone
            },
            {
                path: '/goods/singleproduct/detail',
                name: 'detail',
                component: detail
            }
            ]
        },
        { // 个人中心
            path: '/my',
            name: 'my',
            component: my,
            children: [{
                path: '/my/myinfo',
                name: 'myinfo',
                component: myinfo,
            },
            {
                path: '/my/api',
                name: 'api',
                component: api,
            },
            {
                path: '/my/mypid',
                name: 'mypid',
                component: mypid,
            },
            {
                path: '/my/myjdpid',
                name: 'myjdpid',
                component: myjdpid,
            },
            {
                path: '/my/server',
                name: 'server',
                component: server,
            },
            {
                path: '/my/heads',
                name: 'heads',
                component: heads,
            },
            {
                path: '/my/kollist',
                name: 'kollist',
                component: kollist,
            },
            {
                path: '/my/usercalendar',
                name: 'usercalendar',
                component: usercalendar,
            },
            {
                path: '/my/usercalendar/usercalendarinfo',
                name: 'usercalendarinfo',
                component: usercalendarinfo,
            },
            {
                path: '/my/transaction',
                name: 'transaction',
                component: transaction,
            }, ,
            {
                path: '/cooperation/launchgoods',
                name: 'launchgoods',
                component: launchgoods,
            },
            {
                path: '/cooperation/cooperation',
                name: 'cooperation',
                component: cooperation,
            },
            {
                path: '/cooperation/mycalendar',
                name: 'mycalendar',
                component: mycalendar,
            },
            {
                path: '/my/orderlist',
                name: 'orderlist',
                component: orderlist,
            },
            {
                path: '/my/orderlist/partner_info',
                name: 'partner_info',
                component: partner_info,
            },
            {
                path: '/my/orderlist/media_questions',
                name: 'media_questions',
                component: media_questions,
            },
            {
                path: '/my/ordertask/portrait_fans',
                name: 'portrait_fans',
                component: portrait_fans
            },
            {
                path: '/my/usercalendar/portrait_fans',
                name: 'portrait_fans',
                component: portrait_fans
            },
            {
                path: '/my/orderlist/portrait_fans',
                name: 'portrait_fans',
                component: portrait_fans
            },
            
                // {
                //     path: '/my/example',
                //     name: 'example',
                //     component: example, 
                // }
            {
                path: '/my/ordertask',
                name: 'ordertask',
                component: ordertask
            },
            {
                path: '/my/ordertask/ordertaskdetail',
                name: 'ordertaskdetail',
                component: ordertaskdetail
            },
            {
                path: '/my/loadtask',
                name: 'loadtask',
                component: loadtask,
            },
            {
                path: '/my/loadtask/portrait_fans',
                name: 'portrait_fans',
                component: portrait_fans
            },
            {
                path: '/my/loadtask/loaddetail',
                name: 'loaddetail',
                component: loaddetail, 
            },
            {
                path: '/my/cooperativegoods',
                name: 'cooperativegoods',
                component: cooperativegoods
            },
            {
                path: '/my/cooperativegoods/cooperativehistory',
                name: 'cooperativehistory',
                component: cooperativehistory
            },
            {
                path: '/my/cooperativegoods/cooperativehistory/cooperativedetail',
                name: 'cooperativedetail',
                component: cooperativedetail
            }
            ]
        },
        //cpx部分
        {
            path: '/cpx',
            name: 'cpx',
            component: cpx,
            children: [
                {
                    path: '/cpx/cpxprogress',
                    name: 'cpxprogress',
                    component: cpxprogress,
                },
                {
                    path: '/cpx/cpxruning',
                    name: 'cpxruning',
                    component: cpxruning,
                },
                {
                    path: '/cpx/cpxend',
                    name: 'cpxend',
                    component: cpxend,
                }
            ]
        },














        // 这是最下面的路由 请往上写
        {
            path: '*',
            name: 'A404',
            component: A404
        },

    ]
});
r.beforeEach((to, from, next) => {
    if (to.name == 'forgotpassword' || to.name == 'registerpage' || to.name == 'loginpage') {
        next();
    } else {
        if (to.path !== '/login' && !http.getAuth('auth_token')) {
            next({
                path: '/login',
                query: {
                    code: '401',
                    redirect: to.fullPath != '/login' ? to.fullPath : '/'
                } //
            })
            return false;
        }
        next();
    }


});
r.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});
export default r;